import { Check } from 'lucide-react'
import { Visibility } from '../../types/visibility'
import { VISIBILITY_META } from '../../lib/visibilityMeta'

interface VisibilitySelectorProps {
  value: Visibility
  disabled?: boolean
  // Specify a subset of options to render (defaults to all three). Used by the
  // Upload form to hide the selector entirely when the image inherits the
  // album's visibility, for example.
  options?: Visibility[]
  onChange: (value: Visibility) => void
}

export const VisibilitySelector = ({
  value,
  disabled,
  options = ['public', 'discoverable', 'private'],
  onChange,
}: VisibilitySelectorProps) => {
  return (
    <div className="flex gap-4 flex-wrap">
      {options.map((v) => {
        const meta = VISIBILITY_META[v]
        const selected = value === v
        const Icon = meta.icon
        return (
          <button
            key={v}
            type="button"
            disabled={disabled}
            onClick={() => onChange(v)}
            className={`flex-1 flex items-center gap-3 p-4 rounded-xl border-2 transition-all min-w-[160px] text-left ${
              selected
                ? 'border-blue-500 bg-blue-50 text-blue-700'
                : 'border-gray-200 hover:border-gray-300 text-gray-600'
            } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <Icon className={`w-5 h-5 ${selected ? 'text-blue-500' : meta.iconClass}`} />
            <div className="flex-1">
              <div className="font-medium">{meta.label}</div>
              <div className="text-xs opacity-75">{meta.description}</div>
            </div>
            {selected && <Check className="w-5 h-5 ml-auto" />}
          </button>
        )
      })}
    </div>
  )
}